module.exports = __webpack_public_path__ + "static/media/toyota-black-logo.cc800e55.svg";